"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMultipleBosCustomersQuery = exports.getBosCustomerQuery = exports.findBosCustomerQuery = exports.bosCustomerQuery = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.bosCustomerQuery = `
  query searchCustomer($phoneNumber: Float, $orgNumber: Float) {
    searchCustomer(phoneNumber: $phoneNumber, orgNumber: $orgNumber) {
      ...bosCustomer
    }
  }
  ${fragments_1.bosCustomerFragment}
`;
exports.findBosCustomerQuery = `
  query findCustomer( $phoneNumber: Float $orgNumber: Float ) {
    findCustomer( phoneNumber: $phoneNumber orgNumber: $orgNumber ) {
      ...bosCustomer
    }
  }
  ${fragments_1.bosCustomerFragment}
`;
exports.getBosCustomerQuery = `
  query getCustomer($customerId: String) {
    getCustomer(customerId: $customerId) {
      ...bosCustomer
    }
  }
  ${fragments_1.bosCustomerFragment}
`;
exports.getMultipleBosCustomersQuery = `
  query getCustomers($customerIds: [String!]) {
    getCustomers(customerIds: $customerIds) {
      id
      firstName
      lastName
      phoneMobile
    }
  }
`;
//# sourceMappingURL=customerQuery.js.map